import { memo } from 'react';
import type { DialogProps as MuiDialogProps } from '@mui/material';
import { Dialog as MuiDialog, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { cx } from '@emotion/css';

import cn from './dialog.module.scss';
import globalCn from '../../scss/app.module.scss';

import { useIsMobile } from '../../hooks/useIsDevice';

export type DialogPropsType = Omit<MuiDialogProps, 'onClose'> & {
    loading?: boolean;
    showCloseButton?: boolean;
    onClose: () => void;
}
const Dialog = ({ onClose, open, loading, children, showCloseButton, className, ...props }: DialogPropsType) => {

    const isMobile = useIsMobile();

    const handleClose = () => {
        if (loading) return;
        onClose();
    };

    return (
        <MuiDialog
            open={open}
            fullScreen={isMobile}
            onClose={handleClose}
            {...props}
            className={cx(globalCn.app, className)}
        >
            {children}
            {(isMobile || showCloseButton) && (
                <IconButton className={cn.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            )}
        </MuiDialog>
    );

};

export default memo(Dialog);
